module.exports = __webpack_public_path__ + "img/v2.41b8c89d.png";